<template>
  <div>
    <p class="title" v-if="displayData">語法懶人包</p>
    <ul class="main notice-data">
      <li v-for="(item, index) in css" :key="index"
       v-if="displayData[item.name]" :class="{'noHand': !item.copy}">
        <p @click="doCopy(item.name, index, item.copy)" :class="{'copied': temp.copyCss === index}">
          {{item.name}} <i class="far fa-copy" v-if="item.copy"></i>
        </p>
        <div class="contain">
          <ul>
            <li @click="doCopy2(ii, item.name, iii, item.copy)"
             v-for="(ii, iii) in item.attr" :key="iii"
              :class="{'copied': temp.copyCss2 === iii}">
              {{ii}}<i class="fas fa-copy" v-if="item.copy"></i>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import copy from 'copy-text-to-clipboard';
import { setTimeout } from 'timers';

export default {
  name: 'Notice',
  props: ['displayData'],
  data() {
    return {
      css: [
        {
          name: 'justify-content',
          copy: true,
          attr: ['flex-start', 'flex-end', 'space-around', 'center', 'space-between', 'stretch'],
        },
        {
          name: 'align-items',
          copy: true,
          attr: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
        },
        {
          name: 'flex-wrap',
          copy: true,
          attr: ['nowrap', 'wrap', 'wrap-reverse'],
        },
        {
          name: 'flex-direction',
          copy: true,
          attr: ['row', 'row-reverse', 'column', 'column-reverse'],
        },
        {
          name: 'align-content',
          copy: true,
          attr: ['flex-start', 'flex-end', 'space-around', 'center', 'space-between', 'stretch'],
        },
        {
          name: 'order',
          copy: false,
          attr: ['數字越大，排越後面', '-1 可排到最前', '0 為預設值'],
        },
        {
          name: 'flex',
          copy: false,
          attr: ['flex-basis 為基本大小', 'flex-grow 為剩餘空間分配', 'flex-shrink 為縮小空間配置'],
        },
      ],
      temp: {
        copyCss: null,
        copyCss2: null,
      },
    };
  },
  methods: {
    doCopy(text, i, copyR) {
      if (copyR) {
        copy(text);
        this.temp.copyCss = i;
        setTimeout(() => {
          this.temp.copyCss = null;
        }, 300);
      }
    },
    doCopy2(text, key, i, copyR) {
      if (copyR) {
        copy(`${key}:${text};`);
        this.temp.copyCss2 = i;
        setTimeout(() => {
          this.temp.copyCss2 = null;
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title{
  font-size: 10px;
  margin-top: 20px;
  font-weight: bold;
  color: #555;
}
.main{
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  &.notice-data{
    .copied{
      filter: brightness(130%);
    }
    .noHand{
      *{
        cursor: text !important;
      }
    }
    li{
      position: relative;
      margin-right: 5px;
      margin-top: 3px;
      p{
        background-color: #2bbd7e;
        transition: all 0.2s ease-in-out;
        color: #fff;
        font-size: 14px;
        padding: 1px 5px;
        border-radius: 3px;
        cursor: pointer;
        i{
          margin-left: 5px;
          opacity: 0.5;
        }
      }
      .contain{
        display: none;
        position: absolute;
        font-size: 14px;
        background-color: #00251a;
        color: #fff;
        padding: 15px 20px;
        z-index: 10;
        border-radius: 3px;
        white-space: nowrap;
        line-height: 1.5;
        li{
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: 0.2s ease-in-out;
          &.copied{
            text-shadow: 0 0 6px #fff;
          }
          i{
            opacity: 0;
            margin-left: 8px;
            transition: opacity 0.2s ease-in-out;
          }
          &:hover{
            i{
              opacity: .5;
            }
          }
        }
      }
      &:hover{
        .contain{
          display: block;
        }
      }
    }
  }
}
</style>
